import { Strings } from '@app/constants';
import { IAssetSchema } from '../types';
import { InternalSubCard } from '@app/components/card';

interface Props {
  userData: IAssetSchema;
}
export const AssetsInfo = ({ userData }: Props) => {
  const assetData =
    userData?.assets?.length > 0
      ? userData.assets
      : [{ assetName: 'NA', purchaseDate: 'NA', warranty: 'NA', status: 'NA' }];
  const subCards = assetData.map((asset, index) => ({
    fields: [
      Strings.assets.assetName,
      Strings.assets.purchaseDate,
      Strings.assets.warranty,
      Strings.assets.status,
    ],
    data: [
      asset.assetName || 'NA',
      asset.purchaseDate || 'NA',
      asset.warranty || 'NA',
      asset.status || 'NA',
    ],
  }));

  return (
    <>
      <InternalSubCard
        title={Strings.profile.assetsInformation}
        subCards={subCards}
        height={'270px'}
        iconImg="ic_assets"
      />
    </>
  );
};
